import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import { CarouselWrapper, ThumbnailImg, ThumbnailSliderWrapper } from './BasicCarouselWithThumbs.style'
import HeroBanner from '../HeroBanner'
import { getImageURL } from '../../../utils/siteHelper'

const BasicCarouselWithThumbs = ({ fillScreen, carouselItems, thumbnails, mobileCarouselItems }) => {
  const [nav1, setNav1] = useState()
  const [nav2, setNav2] = useState()
  const slider1 = useRef(null)
  const slider2 = useRef(null)

  useEffect(() => {
    setNav1(slider1.current)
    setNav2(slider2.current)
  }, [])

  const settingCarousel = {
    className: 'mainslider',
    fade: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 5,
          slidesPerRow: 1,
        },
      },
    ],
  }

  const settingsSliderNav = {
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    focusOnSelect: true,
    className: 'thumbnailslider',
    adaptiveHeight: true,
    swipeToSlide: true,
  }

  const mobileCarousel = {
    className: 'mobileslider',
    fade: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 5,
          slidesPerRow: 1,
        },
      },
    ],
  }

  return (
    <CarouselWrapper fillScreen={fillScreen}>
      <Slider asNavFor={nav2} ref={slider1} {...settingCarousel}>
        {carouselItems &&
          carouselItems.map((bannerContent) => (
            <HeroBanner
              key={bannerContent.id}
              isCarousel
              fillScreen={fillScreen}
              {...bannerContent}
            />
          ))}
      </Slider>
      <ThumbnailSliderWrapper>
        <Slider asNavFor={nav1} ref={slider2} {...settingsSliderNav}>
          {thumbnails &&
            thumbnails.map((thumbnailContent) => (
              <div key={thumbnailContent.id} className="thumbnailWrap">
                <div className="caption">{thumbnailContent.imageTitle}</div>
                <ThumbnailImg
                  src={getImageURL(thumbnailContent)}
                  {...thumbnailContent}
                />
              </div>
            ))}
        </Slider>
      </ThumbnailSliderWrapper>
      <Slider {...mobileCarousel}>
        {mobileCarouselItems &&
          mobileCarouselItems.map((bannerContent) => (
            <HeroBanner
              key={bannerContent.id}
              isCarousel
              fillScreen={fillScreen}
              {...bannerContent}
            />
          ))}
      </Slider>
    </CarouselWrapper>
  )
}

BasicCarouselWithThumbs.propTypes = {
  title: PropTypes.string.isRequired,
  fillScreen: PropTypes.bool,
  carouselItems: PropTypes.shape({
    HeroBanner: PropTypes.object,
  }).isRequired,
  thumbnails: PropTypes.shape({
    imageFile: PropTypes.object,
  }).isRequired,
  mobileCarouselItems: PropTypes.shape({
    HeroBanner: PropTypes.object,
  }).isRequired,
}

BasicCarouselWithThumbs.defaultProps = {
  fillScreen: false,
}

export const BasicCarouselWithThumbsFragment = graphql`
  fragment BasicCarouselWithThumbsFragment on ContentfulBasicCarouselWithThumbs {
    title
    fillScreen
    carouselItems {
      ...HeroBannerFragment
    }
    thumbnails {
      ...ImageFragment
    }
    mobileCarouselItems {
      ...HeroBannerFragment
    }
  }
`

export default BasicCarouselWithThumbs
